/*    
<summary>
  This functional component is used for proper authentication of user using the StaffLogin Credentials (Username & Password)
  Developer:Aashish Singh, Created Date:28-Aug-2022, Last Updated By: Mohammad Saquib Khan, Updated Date: 26-Oct-2022
</summary>
<returns>Returns JSX</returns>
*/

import React, { useEffect } from "react";
import { toast } from "react-toastify";
import "./login.css";
import { formatMessage } from "../../translations/format-message";
import { observer } from "mobx-react";
import { useStore } from "../../contexts/store-provider";
import { useCookies } from "react-cookie";
import ILogin, { IUserTypeLogin } from "../../models/forms/ILogin";
import RoutesConstants from "../../shared-components/routes/routes-constants";
import LoginForm from "./forms/login-form";
import Footer from "../../shared-components/footer/footer";
import { errorMessage } from "../../constants/error-constants";
import { useHistory, useLocation } from "react-router-dom";
import userTypeEnum from "../../constants/enums/user-type-enum";
import { getUserTypeFromLocalStorage } from "../../helpers/localstorage-helper";

const StaffLogin = (props: any) => {
  const history = useHistory();
  const location: {state:number} = useLocation();
  const selectedUserType = 2;
  const { authStore } = useStore();

  const { error, inProgress }: any = authStore;
  const { isAuthenticated, getToken, login, loginAsStoreService } = authStore;
  const initialValues: IUserTypeLogin = {
    email: "",
    password: "",
    storeCode: "",
    userType: selectedUserType,
    rememberMe: false,
  };

  /**
   * This function handles login functionlity for user
   */
  const handleLogin = (values: IUserTypeLogin) => {
    login({email: values.email, password: values.password, userType: values.userType});
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "isAuthenticated" of the useEffect changed.
   */
  useEffect(() => {
    if (isAuthenticated || getToken) {
      let userType = getUserTypeFromLocalStorage();
      if(userType == userTypeEnum[2]) history.push(RoutesConstants.ShiftManagement);
      else history.push(RoutesConstants.StaffLogin);
    }
  }, [isAuthenticated]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "error" of the useEffect changed.
   */
  useEffect(() => {
    if (error) {
      if (error === errorMessage.UserAlreadyLogin) {
        props.confirmLoginPopupToggleHandler();
      } else {
        toast.error(formatMessage(error));
        authStore.reset();
      }
    }
  }, [error]);

  return (
    <>
      <LoginForm
        isLoading={inProgress}
        loginHandler={handleLogin}
        initialValues={initialValues}
      />
      <Footer />
    </>
  );
};

export default observer(StaffLogin);
